import request from '@/utils/request'


// 查询赛事证书信息列表
export function listCompetitionCertificate(query) {
  return request({
    url: '/platform/competition-certificate/list',
    method: 'get',
    params: query
  })
}

// 查询赛事证书信息分页
export function pageCompetitionCertificate(query) {
  return request({
    url: '/platform/competition-certificate/page',
    method: 'get',
    params: query
  })
}

// 查询赛事证书信息详细
export function getCompetitionCertificate(data) {
  return request({
    url: '/platform/competition-certificate/detail',
    method: 'get',
    params: data
  })
}

// 转化证书图章
export function syncSeal(data) {
  return request({
    url: '/platform/competition-certificate/syncSeal',
    method: 'get',
    params: data
  })
}

// 新增赛事证书信息
export function addCompetitionCertificate(data) {
  return request({
    url: '/platform/competition-certificate/add',
    method: 'post',
    data: data
  })
}

// 修改赛事证书信息
export function updateCompetitionCertificate(data) {
  return request({
    url: '/platform/competition-certificate/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事证书信息
export function delCompetitionCertificate(data) {
  return request({
    url: '/platform/competition-certificate/delete',
    method: 'post',
    data: data
  })
}
